import { z } from "zod";

export const particleOriginSchema = z.enum(["participant", "admin-test", "seed"]);
export type ParticleOrigin = z.infer<typeof particleOriginSchema>;

export const particleSchema = z.object({
  id: z.string().uuid(),
  /**
   * Monotonic per server lifetime and the DB ordering key. Lets a client detect
   * gaps and lets the visuals reproduce insertion order exactly after a reload.
   */
  seq: z.number().int().nonnegative(),
  /**
   * Deterministic randomness for the (not yet designed) particle look, so the same
   * particle looks identical after an F5. Integer, because floats drift through JSON.
   */
  seed: z.number().int().min(0).max(1_000_000),
  /**
   * Placeholder for a form-derived variant, normalized 0..1. Null while the creative
   * mapping is undecided; every particle then looks the same.
   */
  tone: z.number().min(0).max(1).nullable(),
  origin: particleOriginSchema,
  /** Epoch ms, server clock. */
  createdAt: z.number().int(),
  /** Which round this particle belongs to. Incremented by an admin reset. */
  round: z.number().int().nonnegative(),
});
export type ParticleDTO = z.infer<typeof particleSchema>;
